// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_ChaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** InputContract for GET /config/traducoes/chave — one key of one page, in every language. */
import { registerContract } from './validate'

export interface Traducoes_ChaveInput {
pagina?: string
chave?: string
}

registerContract('Traducoes_ChaveInput', {
  pagina: { type: 'string',  required: false },
  chave:  { type: 'string',  required: false },
})
